import { Fragment } from "react";
import { Link } from "react-router-dom";
import NavbarDashboard from "components/organism/Navbar/NavbarDashboard";

const NotFound = () => {
    return (
        <Fragment>
            <NavbarDashboard />
            <div className="w-full max-w-[700px] mx-auto text-center mt-14 px-6 tablet:px-8 desktop:px-[120px]">
                <h1 className="font-semibold text-[120px] text-neutral-100">404</h1>
                <h1 className="font-semibold text-3xl text-neutral-100">Page Not Found</h1>
                <p className="text-sm font-normal text-neutral-60 mt-2 mb-5">Sorry, page you visit is not found, go back to Homepage</p>
                <Link to="/" className="relative z-20">
                    <button className="py-[18px] w-full md:w-fit tablet:px-[39px] px-[45.5px] font-semibold rounded-lg bg-primary-main hover:bg-primary-hover text-md text-basier-circle-semibold text-neutral-10">Back to Homepage</button>
                </Link>
            </div>
        </Fragment>
    );
};

export default NotFound;